<template>
  <div>
    <span>{{ object.business_type === 'medical' ? 'Общ' : 'Стом' }}</span>
  </div>
</template>

<script setup>
defineProps({
  object: {
    type: Object
  },
})
</script>
